import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

interface LayoutProps {
  children: ReactNode;
  transparentNav?: boolean;
}

const Layout = ({ children, transparentNav = false }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar transparent={transparentNav} />
      <main className={`flex-1 ${transparentNav ? "pt-20 sm:pt-0" : "pt-20"}`}>{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
